import { cn } from '@/lib/utils'

interface LumooSpinnerProps {
  size?: number
  className?: string
  rayColor?: string
  speedMs?: number
}

export function LumooSpinner({
  size = 120,
  className,
  rayColor = 'currentColor',
  speedMs = 3000,
}: LumooSpinnerProps) {
  const rayCount = 16
  const rayLength = size * 0.2
  const rayWidth = size * 0.018
  const innerRadius = size * 0.18
  const centerOffset = size * 0.35

  const createRays = (cx: number, cy: number, angleOffset: number = 0) => {
    const rays = []
    for (let i = 0; i < rayCount; i++) {
      const angle = (i * 360) / rayCount + angleOffset
      const radians = (angle * Math.PI) / 180
      const x1 = cx + Math.cos(radians) * innerRadius
      const y1 = cy + Math.sin(radians) * innerRadius
      const x2 = cx + Math.cos(radians) * (innerRadius + rayLength)
      const y2 = cy + Math.sin(radians) * (innerRadius + rayLength)
      rays.push(
        <line
          key={i}
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke={rayColor}
          strokeWidth={rayWidth}
          strokeLinecap='round'
        />
      )
    }
    return rays
  }

  const viewBoxSize = size
  const leftCenter = viewBoxSize / 2 - centerOffset
  const rightCenter = viewBoxSize / 2 + centerOffset

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
      className={cn('text-foreground overflow-visible', className)}
    >
      <style>
        {`
          @keyframes spin-clockwise {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          @keyframes spin-counter-clockwise {
            from { transform: rotate(0deg); }
            to { transform: rotate(-360deg); }
          }
        `}
      </style>
      <g
        style={{
          transformOrigin: `${leftCenter}px ${viewBoxSize / 2}px`,
          animation: `spin-clockwise ${speedMs}ms linear infinite`,
        }}
      >
        {createRays(leftCenter, viewBoxSize / 2, 360 / rayCount / 2)}
      </g>
      <g
        style={{
          transformOrigin: `${rightCenter}px ${viewBoxSize / 2}px`,
          animation: `spin-counter-clockwise ${speedMs}ms linear infinite`,
        }}
      >
        {createRays(rightCenter, viewBoxSize / 2)}
      </g>
    </svg>
  )
}
